import React, { useState } from "react";
import { ActionPanel } from "components/panel";
import { Button } from "components/buttons";
import PropTypes from "prop-types";
import { LicenceCheckingNewConsentModal } from "pages/licence-checking/shared/new-consent";

export function NoDvlaRecordPanel({ checkData, reloadCheck }) {
    const [showModal, setShowModal] = useState(false);

    function handleSuccess() {
        setShowModal(false);
        reloadCheck();
    }

    return (
        <div className="spacer-top">
            <ActionPanel intent="warning" title="No DVLA Record Found">
                <div>
                    <p className="spacer-bottom">
                        No records were found for the for the information
                        provided in the driver declaration. To restart the
                        process please click the button below.
                    </p>
                    <Button
                        id="add-question-type"
                        onClick={() => setShowModal(true)}
                        text={"Restart Declaration"}
                        icon="reset"
                        intent="Primary"
                    />
                </div>
            </ActionPanel>

            <LicenceCheckingNewConsentModal
                isOpen={showModal}
                employeeId={checkData?.employeeId}
                emailAddress={checkData?.emailAddress}
                employeeName={checkData?.employeeName}
                onSuccess={handleSuccess}
                onClose={() => setShowModal(false)}
                consentExists={true}
            />
        </div>
    );
}

NoDvlaRecordPanel.propTypes = {
    checkData: PropTypes.object.isRequired,
    reloadCheck: PropTypes.func.isRequired,
};
